import helper from './helper'

export default {
  async getByMediaId(id) {
    return await helper.get(`/api/media-channels/${id}`)
  },
  async getByChannelId(id) {
    return await helper.get(`/api/media-channels/by-channel/${id}`)
  }
}
